/* eslint-disable import/extensions,import/no-unresolved,import/no-duplicates */
import { stepBaggageAndPersonalItemsStarrLookup as expenseLookup } from './claimCodeMapper';

function mapToParentSection() {
  return {};
}

function mapToQuestionnaire(data, claimCode) {
  const questionnaire = [];
  const entries = Object.entries(data);
  const excludedEntries = ['descriptionOfItems',
    'descriptionOfItemsForDamaged',
    'specifiedItems',

    "flightDetailsForBaggageDelay",
    "cruiseLineDetailsBaggageDelay",
    "otherDetailsBaggageDelay",

    "flightDetailsForDamaged",
    "cruiseLineDetailsForDamaged",
    "otherDetailsForDamaged",
  ];
  entries.forEach(([property, value]) => {
    if (excludedEntries.indexOf(property) < 0) {
      questionnaire.push({
        question: `section12.${property}`,
        answer: value,
        claimTypeCode: claimCode,
      });
    }
  });
  return [...questionnaire];
}

function mapToExpenses(data) {
  const damagedLostExpenses = mapToDamagedLostExpense(data);
  const baggageDelayExpenses = mapToBaggageDelayExpense(data);

  const benefitName = 'Baggage and Personal Items';
  const expenses = [
    ...damagedLostExpenses,
    ...baggageDelayExpenses
  ].map(e => ({ ...e, benefitName }));
  return expenses;
}

function mapToDamagedLostExpense(data) {
  if (data.areYouClaimingForDamagedLostOrStolenLuggage !== 'true' || data.descriptionOfItems.length < 1) {
    return [];
  }
  const claimCode = expenseLookup.areYouClaimingForDamaged.claimCode;
  const expenses = [];

  data.descriptionOfItems.forEach(
    (item) => {
      const expense = mapLossItemExpense(item, data, claimCode);
      if (!!expense) {
        expenses.push(expense);
      }
      const reimburseExpense = mapReimbursement(item, data, claimCode);
      if (!!reimburseExpense) {
        expenses.push(reimburseExpense);
      }
    }
  );

  return expenses;
}

function mapToBaggageDelayExpense(data) {
  if (data.areYouClaimingForBaggageDelay !== 'true' || data.descriptionOfItemsForDamaged.length < 1) {
    return [];
  }
  const claimCode = expenseLookup.areYouClaimingForBaggageDelay.claimCode;
  const expenses = [];

  data.descriptionOfItemsForDamaged.forEach(
    (item) => {
      const expense = mapDelayItemExpense(item, data, claimCode);
      if (!!expense) {
        expenses.push(expense);
      }
      const reimburseExpense = mapReimbursement(item, data, claimCode);
      if (!!reimburseExpense) {
        expenses.push(reimburseExpense);
      }
    }
  );

  return expenses;
}

function mapLossItemExpense(item, formData, claimCode) {
  return mapExpenseItem(item, item.dateOfPurchase, claimCode);
}

function mapDelayItemExpense(item, formData, claimCode) {
  return mapExpenseItem(item, formData.dateWhenYourLuggageWasDelayed, claimCode);
}

function mapExpenseItem(item, itemDate, claimCode) {
  const selectedClaimForArray = item.selectedClaimFor ? (!Array.isArray(item.selectedClaimFor)) ? item.selectedClaimFor.toJS() : item.selectedClaimFor : [];
  const claimForInsuredIds = selectedClaimForArray.map((claimFor) => claimFor.policyRoleID);
  if (!item || !item.amountClaimed || !item.currentClaimed) {
    return null;
  }
  return {
    shortDescription: `${item.item}`,
    dateOfExpense: itemDate,
    clientCost: item.amountClaimed,
    currency: item.currentClaimed,
    rate: null,
    requestedAmount: null,
    claimTypeCode: claimCode,
    dateOfPurchase: item.dateOfPurchase,
    depreciationType: item.depreciationType,
    claimForInsuredIds,
    claimForInsureds: selectedClaimForArray,
  };
}

function mapReimbursement(item, formData, claimCode) {
  const selectedClaimForArray = item.selectedClaimFor ? (!Array.isArray(item.selectedClaimFor)) ? item.selectedClaimFor.toJS() : item.selectedClaimFor : [];
  const claimForInsuredIds = selectedClaimForArray.map((claimFor) => claimFor.policyRoleID);
  if (!item || !item.howMuch || !item.currencyExpensesClaimed || item.haveYouReceivedReimbursement !== 'true') {
    return null;
  }
  return {
    shortDescription: `${item.fromWhom} (Reimbursement)`,
    dateOfExpense: item.dateReimbursementReceived,
    clientCost: `${item.howMuch * -1}`,
    currency: item.currencyExpensesClaimed,
    rate: null,
    requestedAmount: null,
    claimTypeCode: claimCode,
    claimForInsuredIds,
    claimForInsureds: selectedClaimForArray,
  };
}

export default {
  mapToParentSection,
  mapToQuestionnaire,
  mapToExpenses,
};



// WEBPACK FOOTER //
// ./app/containers/FastCover/dataMapper/stepBaggageAndPersonalItemsStarrDataMapper.js